/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Open_MenuInputs */

const es_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

const gl_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

const en_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Nav_Open_MenuInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_open_menu = /** @type {((inputs?: Nav_Open_MenuInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Open_MenuInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_open_menu(inputs)
	if (locale === "en") return en_nav_open_menu(inputs)
	return es_nav_open_menu(inputs)
});